import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take, withLatestFrom } from 'rxjs/operators';
import { selectLoginState } from 'src/app/auth/ngrx/auth.selectors';
import { State } from 'src/app/reducers';
import { User } from 'src/app/shared/Models/user';
import { selectUser } from 'src/app/shared/user/ngrx/user.selectors';

export const userResolver: ResolveFn<User | null> = () => {
  const ngrxStore = inject(Store) as Store<State>;

  const user$ = ngrxStore.select(selectUser);
  const isLoggedIn$ = ngrxStore.select(selectLoginState);

  return user$.pipe(
    withLatestFrom(isLoggedIn$),
    filter(([usr, isLoggedIn]) => !isLoggedIn || !!usr?.url),
    map(([usr, isLoggedIn]) => (isLoggedIn ? usr : null)),
    take(1),
  );
};
